module.exports = __webpack_public_path__ + "static/img/a9fcf6bcd200d0625379fcca9543b167.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/图片2.png
// module id = ywgp
// module chunks = 1